import React, { useMemo, useState } from "react";
import "./Gddcn.css";

const TABS = [
  { key: "den", label: "ĐÈN NGỦ, ĐÈN TRANG TRÍ" },
  { key: "phu-kien", label: "PHỤ KIỆN DI ĐỘNG" },
  { key: "may-xong", label: "MÁY XÔNG, QUẠT MINI" },
  { key: "do-choi", label: "ĐỒ CHƠI CÔNG NGHỆ" },
];

const ALL = [
  {
    id: 1,
    tab: "may-xong",
    qty: 100,
    name: "Quạt tích điện Capybara có cánh YM88215",
    price: 39000,
    img: "/5dcn/1.jpeg",
    href: "#",
  },
  {
    id: 2,
    tab: "may-xong",
    qty: 25,
    name: "Quạt tích điện để bàn hình mặt cười YS2310B",
    price: 41500,
    img: "/5dcn/2.jpeg",
    href: "#",
  },
  {
    id: 3,
    tab: "do-choi",
    qty: "-",
    name: "Loa Bluetooth (Không Mic, Không Hộp)",
    price: 40500,
    img: "/5dcn/3.jpeg",
    href: "#",
  },
  {
    id: 4,
    tab: "phu-kien",
    qty: 200,
    name: "Giá Đỡ Điện Thoại (Nhựa)",
    price: 9900,
    img: "/5dcn/4.jpeg",
    href: "#",
    cornerIcon: true,
  },
  {
    id: 5,
    tab: "phu-kien",
    qty: 80,
    name: "Kẹp/Đế Đỡ Tablet - Phone",
    price: 18900,
    img: "/5dcn/5.jpeg",
    href: "#",
  },
  {
    id: 6,
    tab: "den",
    qty: 60,
    name: "Đèn Ngủ Cảm Biến (Mini)",
    price: 25900,
    img: "/5dcn/6.jpeg",
    href: "#",
    soldOut: true,
    cornerIcon: true,
  },
  {
    id: 7,
    tab: "may-xong",
    qty: 35,
    name: "Máy Xông Tinh Dầu (USB)",
    price: 49900,
    img: "/5dcn/7.jpeg",
    href: "#",
  },
  {
    id: 8,
    tab: "may-xong",
    qty: 40,
    name: "Quạt Mini để bàn (màu ngẫu nhiên)",
    price: 29900,
    img: "/5dcn/8.jpeg",
    href: "#",
  },
];

function formatVND(n) {
  return new Intl.NumberFormat("vi-VN").format(n) + "đ";
}

export default function Gddcn() {
  const [tab, setTab] = useState(TABS[0].key);

  const products = useMemo(() => {
    const filtered = ALL.filter((p) => p.tab === tab);
    if (filtered.length >= 8) return filtered.slice(0, 8);
    const rest = ALL.filter((p) => p.tab !== tab);
    return [...filtered, ...rest].slice(0, 8);
  }, [tab]);

  return (
    <section className="ts">
      <div className="ts__container">
        <div className="ts__head">
          <h2 className="ts__title">ĐỒ CÔNG NGHỆ</h2>

          <div
            className="ts__tabs"
            role="tablist"
            aria-label="Danh mục đồ công nghệ"
          >
            {TABS.map((t) => (
              <button
                key={t.key}
                type="button"
                className={`ts__tab ${tab === t.key ? "is-active" : ""}`}
                onClick={() => setTab(t.key)}
                role="tab"
                aria-selected={tab === t.key}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="ts__grid">
          {products.map((p) => (
            <a className="ts__card" href={p.href} key={p.id}>
              <div className="ts__media">
                <img
                  className="ts__img"
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                />

                {p.cornerIcon && (
                  <span className="ts__cornerIcon" aria-hidden="true" />
                )}

                {p.soldOut && (
                  <span className="ts__soldOut" aria-label="Tạm hết">
                    Tạm hết
                  </span>
                )}
              </div>

              <div className="ts__meta">
                <div className="ts__name">
                  <span className="ts__qty">[{p.qty}]</span>{" "}
                  <span className="ts__nameText">{p.name}</span>
                </div>
                <div className="ts__price">{formatVND(p.price)}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
